import React from 'react';

import { css } from '@emotion/react';
import { Type } from '@robinhood/design';
import { AddressParts } from '@x1/util-format';

import { AddressType } from 'src/clients/Network/gql/types/address';
import Button from 'src/components/creditApplication/Button';
import Cell from 'src/components/creditApplication/Cell';
import CreditApplicationPageLayout from 'src/components/creditApplication/CreditApplicationPageLayout';

interface PropsIface {
  suggestedAddress: AddressType;
  onAccept: () => void;
  onReject: () => void;
  loading: boolean;
}

type ButtonId = 'accept-button' | 'reject-button';

const buttonState = (loading: boolean, wasPressed: boolean) => {
  if (loading) {
    return wasPressed ? 'loading' : 'disabled';
  } else {
    return false;
  }
};

const AddressSuggestionPage = ({ suggestedAddress, onAccept, onReject, loading }: PropsIface) => {
  const addressParts = AddressParts(suggestedAddress);
  const [pressedButton, setPressedButton] = React.useState<ButtonId | null>(null);

  const _onAccept = React.useCallback(() => {
    setPressedButton('accept-button');
    onAccept();
  }, [onAccept]);

  const _onReject = React.useCallback(() => {
    setPressedButton('reject-button');
    onReject();
  }, [onReject]);

  return (
    <CreditApplicationPageLayout title='Suggested address' subtitle='Consider using this formatted address:'>
      <div css={root}>
        <Cell>
          <div css={addressContainer}>
            <Type.Text size='M' isBold>
              {addressParts.addressLine1}
            </Type.Text>
            <Type.Text size='M'>{addressParts.addressLine2}</Type.Text>
          </div>
        </Cell>
        <div css={buttonContainer}>
          <Button
            label='Accept suggested address'
            type='button'
            width='full'
            onClick={_onAccept}
            state={buttonState(loading, pressedButton === 'accept-button')}
          />
          <Button
            label='Keep address you entered'
            type='button'
            width='full'
            onClick={_onReject}
            variant='secondary'
            state={buttonState(loading, pressedButton === 'reject-button')}
          />
        </div>
      </div>
    </CreditApplicationPageLayout>
  );
};

const root = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 40px;
`;

const addressContainer = css`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const buttonContainer = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export default AddressSuggestionPage;
